import React, {Component} from "react";
import PropTypes from "prop-types";
import {Card} from "react-bootstrap";
import "../Elements/FromGroup/form_select.css"
import AscModal from "../Elements/Modal/Modal";
import {ViewSerialNumber, ViewUserId, ViewUserName, ViewCreated, ViewLastestsActive, EditDescription} from "../Elements/AscElements/DeviceElements";


export default class DeviceUpdateModal extends Component {

    render() {
        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                onClick={this.props.onClick}>
                <Card variant="info">
                    <Card.Header>
                        <Card.Title>
                            {this.props.langText.Body.DeviceInfo}
                        </Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <ViewSerialNumber
                            state={this.props.state}
                            langText={this.props.langText}
                        />
                        <ViewUserId
                            state={this.props.state}
                            langText={this.props.langText}
                        />
                        <ViewUserName
                            state={this.props.state}
                            langText={this.props.langText}
                        />
                        <ViewCreated
                            state={this.props.state}
                            langText={this.props.langText}
                            getMomentTime={this.props.getMomentTime}
                        />
                        <ViewLastestsActive
                            state={this.props.state}
                            langText={this.props.langText}
                            getMomentTime={this.props.getMomentTime}
                        />
                        <EditDescription
                            state={this.props.state}
                            langText={this.props.langText}
                            onTextChange = {this.props.onTextChange}
                        />
                    </Card.Body>
                </Card>
            </AscModal>
        );
    }
}

DeviceUpdateModal.propTypes = {
    state: PropTypes.object.isRequired,
    langText: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    validationHandle: PropTypes.func.isRequired,
    getMomentTime: PropTypes.func.isRequired,
    onTextChange: PropTypes.func.isRequired,
    propSetState: PropTypes.func,
};
